export const ROUTES = {
  HOME: '/',
  LANDING: '/landing',
  LOGIN: '/login',
  REGISTER: '/register',
  NEWS_DETAIL: (postId) => `/news/${postId}`,
  NEWS_DETAIL_PATTERN: '/news/:postId',
  WISDOM_LAMP: '/wisdom-lamp',

  // 影片集
  VIDEO_COLLECTION: '/video-collection',

  // 心理測驗護法DNA
  DNA: '/dna',
  DNA_QUESTION: '/dna/question',
  DNA_ANSWER: '/dna/answer',
  
  // 教理問答
  QUIZ: '/quiz',
  QUIZ_QUESTION: (id) => `/quiz/${id}`,
  QUIZ_QUESTION_PATTERN: '/quiz/:id',
  QUIZ_ANSWER: '/quiz/answer',
  
  // 點燈祈福
  LAMP_LIGHTING: '/lamp-lighting',
  LAMP_BULLETIN: '/lamp-bulletin',
  BLESSING_RESULT: '/blessing-result',
  BRANCH_REPORTS: '/branch-reports',
  BRANCH_REPORT_DETAIL: (id) => `/branch-reports/${id}`,
  BRANCH_REPORT_DETAIL_PATTERN: '/branch-reports/:branchId',

  // 寄送明信片
  POSTCARD_CREATE: '/postcard/create',
  POSTCARD_MY: '/postcard/my',
  POSTCARD_VIEW: (shortId) => `/card/${shortId}`,
  POSTCARD_VIEW_PATTERN: '/card/:shortId',

  // Profile Feature（個人資訊）
  PROFILE: '/profile',

  // 禪心連線（實況留言板）
  LIVE_COMMENT: '/live-comment',
  LIVE_COMMENT_BOARD: (boardId) => `/live-comment/${boardId}`,
  LIVE_COMMENT_BOARD_PATTERN: '/live-comment/:boardId',
  LIVE_COMMENT_TOPIC: (boardId, topicId) => `/live-comment/${boardId}/${topicId}`,
  LIVE_COMMENT_TOPIC_PATTERN: '/live-comment/:boardId/:topicId',
  
  // QR Code活動簽到（可附 ?mode=qr 直接開啟個人行動條碼浮層）
  QR_CODE: '/qr-code',
  // QR_CODE_SCAN: '/qr-code/scan',

  // 佛法填字遊戲
  WORD_PUZZLE: '/word-puzzle',

  // 兌換
  REDEEM: '/redeem',
  MASCOT_EXCHANGE: (rewardId) => `/redeem/mascot/${rewardId}`,
  MASCOT_EXCHANGE_PATTERN: '/redeem/mascot/:rewardId',

  // 覺光庭影（會員互動影片區）
  JUE_GUANG: '/jue-guang',
  JUE_GUANG_TOPIC_PATTERN: '/jue-guang/:topicId',
  JUE_GUANG_TOPIC: (topicId) => `/jue-guang/${topicId}`,
  JUE_GUANG_RECORD_PATTERN: '/jue-guang/:topicId/:recordId',
  JUE_GUANG_RECORD: (topicId, recordId) => `/jue-guang/${topicId}/${recordId}`,

  // 中台心傳
  TRANSMISSION: '/transmission',
  TRANSMISSION_DETAIL_PATTERN: '/transmission/:monasteryId',
  TRANSMISSION_DETAIL: (monasteryId) => `/transmission/${monasteryId}`,
  TRANSMISSION_AREA_PATTERN: '/transmission/area/:areaId',
  TRANSMISSION_AREA: (areaId) => `/transmission/area/${areaId}`,

  // 發願樹
  WISH_TREE: '/wish-tree',

  // 護博會
  GUARDIAN_EXPO: '/dharma-support-expo',
  // 講座
  GUARDIAN_EXPO_LECTURE: '/dharma-support-expo/lecture',
  // 技能交換市集
  GUARDIAN_EXPO_MARKET: '/dharma-support-expo/market',
  // 挑戰賽
  GUARDIAN_EXPO_CHALLENGE: '/dharma-support-expo/challenge',
  // 整合儀表板（大螢幕看板用）
  GUARDIAN_EXPO_DASHBOARD: '/dharma-support-expo/dashboard',

  // 飄落特效測試頁（開發用）
  FALLING_PETALS_DEMO: '/dev/falling-petals-demo',
};
